/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimpleDataRequestResource } from './SimpleDataRequestResource';
import {
    SimpleDataRequestResourceFromJSON,
    SimpleDataRequestResourceFromJSONTyped,
    SimpleDataRequestResourceToJSON,
    SimpleDataRequestResourceToJSONTyped,
} from './SimpleDataRequestResource';

/**
 * 
 * @export
 * @interface LogDataRequest
 */
export interface LogDataRequest {
    /**
     * 
     * @type {number}
     * @memberof LogDataRequest
     */
    timeFrom: number;
    /**
     * 
     * @type {number}
     * @memberof LogDataRequest
     */
    timeTo: number;
    /**
     * 
     * @type {number}
     * @memberof LogDataRequest
     */
    errorDuration: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogDataRequest
     */
    generatorStatus?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogDataRequest
     */
    locale: string;
    /**
     * 
     * @type {Array<SimpleDataRequestResource>}
     * @memberof LogDataRequest
     */
    resources: Array<SimpleDataRequestResource>;
}

/**
 * Check if a given object implements the LogDataRequest interface.
 */
export function instanceOfLogDataRequest(value: object): value is LogDataRequest {
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    if (!('errorDuration' in value) || value['errorDuration'] === undefined) return false;
    if (!('locale' in value) || value['locale'] === undefined) return false;
    if (!('resources' in value) || value['resources'] === undefined) return false;
    return true;
}

export function LogDataRequestFromJSON(json: any): LogDataRequest {
    return LogDataRequestFromJSONTyped(json, false);
}

export function LogDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeFrom': json['timeFrom'],
        'timeTo': json['timeTo'],
        'errorDuration': json['errorDuration'],
        'generatorStatus': json['generatorStatus'] == null ? undefined : json['generatorStatus'],
        'locale': json['locale'],
        'resources': ((json['resources'] as Array<any>).map(SimpleDataRequestResourceFromJSON)),
    };
}

export function LogDataRequestToJSON(json: any): LogDataRequest {
    return LogDataRequestToJSONTyped(json, false);
}

export function LogDataRequestToJSONTyped(value?: LogDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeFrom': value['timeFrom'],
        'timeTo': value['timeTo'],
        'errorDuration': value['errorDuration'],
        'generatorStatus': value['generatorStatus'],
        'locale': value['locale'],
        'resources': ((value['resources'] as Array<any>).map(SimpleDataRequestResourceToJSON)),
    };
}

